module.exports = __webpack_public_path__ + "img/logo_onebox-horizontal-textwhite.2d26177e.png";